
if(process.client){
  var WebFont = require('webfontloader');
}

export default {
  layout: 'gift',
  head() {
    const meta = [
      {
        hid: 'robots',
        name: 'robots',
        content: 'noindex, nofollow'
      },
    ];

    return {
      title: this.$store.getters.getAccount.name,
      meta,
      link: [
        {
          rel: 'icon',
          type: 'image/x-icon',
          href: this.favicon ? this.favicon : '/toggle_favicon.svg'
        },
				{
          rel: 'apple-touch-icon',
          type: 'image/x-icon',
          href: this.webclip ? this.webclip : '/toggle_favicon.svg'
        },
        {
          rel: 'canonical',
          href: 'https://'+this.$store.getters.getAccount.domain
        },
        {
          rel: 'stylesheet',
          href: '/css/tailwindcss.css'
        }
      ]
    }
  },
  mounted() {
    this.setFont();
  },
  computed: {
    accountFonts() {
      return this.$store ? this.$store.getters.getAccountFonts : false;
    },
    favicon() {
      return this.$store.getters.getFavicon;
    },
    webclip() {
      return this.$store.getters.getWebclip;
    }
  },
  methods: {
    setFont() {
      if (!process.client || !this.accountFonts)
        return;

      this.$nextTick(() => {
        WebFont.load({
          google: {
            families: [this.accountFonts]
          }
        });
      });
    },
  }
}
